import React from 'react';
import styled from 'styled-components';

const IllustrateNoRecordsSc = styled.div`
  text-align: center;

  .illustration__no-record {
    width: 13.75rem;
    height: 9.625rem;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    margin: 0 auto 1.5rem auto;
    background-image: url('${(props) => props.imageLink}');

    @media (max-width: 767px) {
      width: 9.5rem;
      height: 6.65rem;
    }
  }

  .no-record-text {
    color: #333;
  }
`;

const IllustrateNoRecords = (props) => {
  const { children, imageLink } = props;
  return (
    <IllustrateNoRecordsSc imageLink={imageLink}>
      <div className="illustration__no-record" />
      {children}
    </IllustrateNoRecordsSc>
  );
};

export default IllustrateNoRecords;
